/* eslint-disable react/no-unused-prop-types */
import clsx from "clsx"
import type { ReactElement } from "react"
import React from "react"

interface SLProps {
  arrLTR?: Array<ReactElement<any>> | undefined
  arrRTL?: Array<ReactElement<any>> | undefined
  wrapperClass?: string
  dividerClass?: string
  addFilter?: boolean
}
interface LogoProps {
  icon: ReactElement<any> | HTMLElement | File | undefined | null | any
  addFilter?: boolean
}

const Logo: React.FC<LogoProps> = ({ icon, addFilter }) => (
  <div className={clsx(addFilter && "invert brightness-0 hover:filter-none")}>
    {icon}
  </div>
)

const ScrollingLogosLTR: React.FC<SLProps> = ({ arrLTR, addFilter }) => (
  <div className="flex items-center h-full min-w-full flex-nowrap whitespace-nowrap animate-slideRight hover:[animation-play-state:paused]">
    <div className="flex items-center flex-grow min-w-full shrink-0 justify-evenly">
      {arrLTR?.map((icon) => (
        <Logo icon={icon} key={icon.key} addFilter={addFilter} />
      ))}
    </div>
    <div className="flex items-center flex-grow min-w-full shrink-0 justify-evenly">
      {arrLTR?.map((icon) => (
        <Logo icon={icon} key={icon.key} addFilter={addFilter} />
      ))}
    </div>
  </div>
)

const ScrollingLogosRTL: React.FC<SLProps> = ({ arrRTL, addFilter }) => (
  <div className="flex items-center h-full min-w-full mt-8 lg:mt-20 flex-nowrap whitespace-nowrap animate-slideLeft hover:[animation-play-state:paused]">
    <div className="flex items-center flex-grow min-w-full shrink-0 justify-evenly">
      {arrRTL?.map((icon) => (
        <Logo icon={icon} key={icon.key} addFilter={addFilter} />
      ))}
    </div>
    <div className="flex items-center flex-grow min-w-full shrink-0 justify-evenly">
      {arrRTL?.map((icon) => (
        <Logo icon={icon} key={icon.key} addFilter={addFilter} />
      ))}
    </div>
  </div>
)

const ScrollingLogos: React.FC<SLProps> = ({
  arrLTR,
  arrRTL,
  wrapperClass,
  dividerClass,
  addFilter = true,
}) => (
  <div className={clsx("overflow-hidden", wrapperClass)}>
    {arrLTR && <ScrollingLogosLTR arrLTR={arrLTR} addFilter={addFilter} />}
    {arrLTR && arrRTL && <div className={clsx(dividerClass)} />}
    {arrRTL && <ScrollingLogosRTL arrRTL={arrRTL} addFilter={addFilter} />}
  </div>
)

export default ScrollingLogos
